// Translation system
import translations from './locales/index.js';

export default translations;